export default __webpack_public_path__ + "static/media/profile-default.56a40438.jpg";